module.exports = __webpack_public_path__ + "static/media/email-verify.5ce2d053.svg";